import { useCallback } from 'react';
import { User } from './types';

export const useMarginTop = (isMobile: boolean, user?: User) => {
  const getMarginTop = useCallback(
    (align?: string): string => {
      if (isMobile) {
        if (user?.backgroundSettings?.headerImageUrl) {
          return align ? '70px' : '140px';
        } else {
          return '20px';
        }
      } else {
        if (user?.backgroundSettings?.headerImageUrl) {
          return align ? '100px' : '180px';
        } else {
          return '0';
        }
      }
    },
    [isMobile, user?.backgroundSettings?.headerImageUrl],
  );

  return { getMarginTop };
};

export default useMarginTop;
